module.exports = __webpack_public_path__ + "img/firm.700850a4.png";